<template>
  <div class="room-event">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'RoomEvent'
}
</script>

<style lang="sass" scoped>
  @import "../styles/global"
  .room-event
    display: grid
    padding: 8px 14px
    background-color: #FFF
    border: 1px solid $secondary-color
    font-size: 14px
    border-radius: 5px
    color: $dark-text-color
    justify-self: center
</style>
